import React, { useState, useEffect } from 'react';
import { Layout, Card, Justify, PagingQuery } from 'tea-component';
import useInitFilterHook from '@intelligence/hooks/useInitFilterHook';
import CommonFilter from '@intelligence/components/CommonFilter';
import SearchRecent from '@/pages/intelligence/components/SearchRecent';
import SteamGamesTable from '@/pages/intelligence/pages/OverlapAnalysis/components/SteamGamesTable';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { overlapAnalysisTopchartSteamGamesRankList } from '@/pages/intelligence/services/overlapAnalysis';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { RecordItemType } from '@/pages/intelligence/components/SearchRecent/type';
import { getCountryFlag } from '@/pages/home/_config/countries';
import useDemographicsRegionsOptions from '@/pages/intelligence/hooks/useDemographicsRegionsOptions';
import { useSelector, useIntl } from 'umi';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import {
  getOverlapAnlysisCountryFilters,
  searchOverlapSteamGames,
} from '@/pages/intelligence/services/filter';
import '@intelligence/assets/scss/OverlapAnalysis/index.scss';
import {
  steamGamesOverlapDefaultFilterValue,
  handleOverlapSteamGameFilterParamsToApi as handleFilterToApiParams,
  steamGamesOverlapDefaultList,
  STEAMOVERLAPMETIRCSLIST,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import { getDbiFilterParams } from '@intelligence/utils/filterUtils';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
const { Body, Content } = Layout;

export default function OverlapAnalysis(props: any) {
  const { marketLoading: filterLoading, allMarkets } = useDemographicsRegionsOptions({
    appIds: [],
    getCountriesFilterFun: getOverlapAnlysisCountryFilters,
  });

  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: hasDataTimerParams?.overlapAnalysis?.type,
  });

  useEffect(() => {
    buriedPointPage(dbiPageLogMes.topchartOverlapAnalysisSteamGames);
  }, []);

  const defaultFilterValue = {
    ...steamGamesOverlapDefaultFilterValue,
  };

  const filterCfg: TopchartFilterCfgType = {
    filterKeyList: [filterKeyMap.ALL_Games, filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO],
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
    },
    showConfirmButton: true,
    haveFilterSaveBtn: false,
    specialParams: {
      [filterKeyMap.ALL_Games]: {
        params: { entity_type: 'pc', game_type: 'current_game' },
        searchAllGamesApi: searchOverlapSteamGames,
        selectGameBtnText: 'dbi_game_selection',
        notSelectTips: 'dbi_compare_please_search_game_above',
      },
    },
  };

  return (
    <OverlapAnalysisComp
      {...props}
      pageLogInfo={dbiPageLogMes.topchartOverlapAnalysisSteamGames}
      filterCfg={filterCfg}
      filterLoading={filterLoading}
      allMarkets={allMarkets}
      rangeTimeComponentDefault={latestTimeTypeHasData}
      defaultInputList={steamGamesOverlapDefaultList}
    />
  );
}

const OverlapAnalysisComp = (props: any) => {
  const { filterLoading: marketLoading, filterCfg, pageLogInfo, defaultInputList } = props;
  const entityType = 'pc';
  const filterState = useSelector((state: any) => state?.[FILTER_EXTEND_NAMESPACE] || {});
  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue;

  const isOperate = filterState?.isOperate;
  const { formatMessage } = useIntl(); // 中英切换方法
  const { filterExtend, setFilterExtend, resetFilterExtend } = useFilterExtend({});
  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });
  // 目前没有筛选器保存功能
  const filterName = ''; // getFilterName(userInfo);
  const filterData = {} as any; // getFilterValueStorage(userInfo);
  const [filterValue, setFilterValue] = useState(isOperate ? filterExtend : DEFAULT_FORM_VALUE);
  // const [filterUrlParams, setFilterUrlParams] = useState({})
  const [tableLoading, setTableLoading] = useState(true);

  const [tableListForClearSearch, setTableListForClearSearch] = useState([]);
  const [totalForClearSearch, setTotalForClearSearch] = useState(0);

  // 宽表总数据条数
  const [tableTotal, setTableTotal] = useState(0);
  // 宽表数据
  const [tableData, setTableData] = useState([]);
  const [fetchParams, setFetchParams] = useState({
    page: 1,
    page_size: 100,
    search_by_name: '', // 列表游戏搜索，为空 表示 全量
    engagement_level_a: '2h',
    engagement_level_b: '2h',
    metrics: STEAMOVERLAPMETIRCSLIST, // 榜单指标
    order_metric: 'source_steam__pcu',
    order: 'desc',
    ratio_type: 0, // 是否环比排序
    filter_ids: [], // 筛选器选中的id
    filter_search_name: '', // 筛选器选中全选时的 搜索字段
    game_code: [], // 列表框上面搜索结果 单选游戏id
  });

  useEffect(() => {
    setTableLoading(true);
    if (!userInfo?.userid || marketLoading) {
      // 拿缓存值需要拿到用户id
      return;
    }
    let newFetchParams = { ...fetchParams };

    const { filterValue, filterParams } = getDbiFilterParams({
      // urlFilter: any,
      filterSaveData: filterData?.apiValue,
      filterExtend,
      specialParams: filterCfg?.specialParams,
      isOperate,
      filterName,
      filterKeyList: filterCfg?.filterKeyList ?? Object.keys(DEFAULT_FORM_VALUE),
    });
    if (isOperate) {
      // 如果目前是继承模式，就设置继承值为过滤后的筛选器值
      setFilterExtend(filterValue);
    }
    setFilterValue(filterValue);

    newFetchParams = {
      ...newFetchParams,
      filter_ids: filterParams?.filter_ids,
      isSearchAll: filterParams?.isSearchAll,
      keywords: filterParams?.keywords,
      engagement_level_a: filterParams?.engagement_level_a || '2h',
      engagement_level_b: filterParams?.engagement_level_b || '2h',
    } as any;
    const params = handleFilterToApiParams(newFetchParams, {});
    getGameData(params);
  }, [userInfo?.userid, marketLoading]);

  const getGameData = async (fetchParams: any, isSearch = false) => {
    const params = {
      ...fetchParams,
      page: isSearch ? 1 : fetchParams.page,
      game_code: isSearch ? fetchParams.game_code : [],
    };
    try {
      setTableData([]);
      setFetchParams(params);
      const res = await overlapAnalysisTopchartSteamGamesRankList(params);
      const { total, rank_list = [] } = res?.data || {};

      // const tableList = handleTableDataFormat(rank_list, params);
      if (!isSearch /* !params?.game_code?.length*/) {
        // 有game_code表示是搜索，则不存页面数据
        setTableListForClearSearch(rank_list || []);
        setTotalForClearSearch(total || rank_list?.length);
      }

      setTableTotal(total || rank_list?.length);
      setTableData(rank_list || []);
    } catch (e) {
      console.error(e);
      setTableData([]);
    } finally {
      setTableLoading(false);
    }
  };

  const onTableSortChage = (e: SortByItemType) => {
    const newFetchParams = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric: e?.sortMetric,
      order_type: e?.orderType,
      ratio_type: e?.ratioType ?? 0,
      page: 1,
      page_size: 100,
    };
    setTableLoading(true);
    getGameData(newFetchParams);
  };

  const onTablePagingChange = (e: PagingQuery) => {
    const newFetchParams = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      page_size: e?.pageSize || 100,
    };
    setTableLoading(true);
    getGameData(newFetchParams);
  };

  const fetchFilterChange = async (value: any) => {
    const params = handleFilterToApiParams(fetchParams, value);

    // 请求接口
    setTableLoading(true);
    await getGameData(params);
  };

  const handleClearSearch = () => {
    setFetchParams({ ...fetchParams, game_code: [] });
    setTableData(tableListForClearSearch);
    setTableTotal(totalForClearSearch);
  };

  const transTableDataForSearch = (res: any) => {
    const resultList = res?.data?.rank_list;
    if (!Array.isArray(resultList) || !resultList?.length) {
      return [];
    }
    const tranksList: RecordItemType[] = resultList.map((item) => {
      return {
        id: `${item?.unified_id}game_id${item?.app_id}`, // uid + appid
        imgSrc: item?.cover,
        lineOneStr: item?.name,
        lineTwoImg: getCountryFlag(item?.markets),
        lineTwoImgName: item?.markets,
        // imageType: '',
        lineTwoStr: item?.publisher,
      };
    });

    return tranksList;
  };

  const getTableSearchList = (id: string) => {
    setTableLoading(true);
    if (typeof id === 'string') {
      const [appid] = id.split('game_id');
      getGameData({ ...(fetchParams || {}), game_code: [appid] }, true);
    }
  };

  // filter公共hooks，暴露全局统一处理filterValue方法，再调接口
  const { updateFilterDatas } = useInitFilterHook({
    entityType,
    filterCfg,
    filterValue,
    setFilterValue,
    filterConfirm: fetchFilterChange,
    isBasicLoading: false,
    ifGetFilterExtend: false,
    ifSetFilterExtend: true,
  });

  return (
    <Layout className="dbi-manage-page">
      <Body>
        <Content className="affix-target dbi-overlapanalysis-page ">
          <Content.Header title={formatMessage({ id: 'dbi_overlapanylistis_steam_title' })} />
          <Content.Body full>
            <MarqueeBanner />
            <Card>
              <Card.Body>
                {/* <Filter
                  filterConfirm={fetchFilterChange}
                  filterReset={() => {}}
                  filterValue={filterValue}
                  setFilterVale={setFilterValue}
                  defaultValue={DEFAULT_FORM_VALUE}
                  filterCfg={filterCfg}
                /> */}
                <CommonFilter
                  filterConfirm={updateFilterDatas}
                  filterValue={filterValue}
                  filterReset={() => {}}
                  setFilterValue={setFilterValue}
                  filterCfg={filterCfg}
                  defaultInputList={defaultInputList}
                />
              </Card.Body>
            </Card>
            <Justify
              className="dbi-card-justify"
              left={
                <div className="dbi-overlapanalysis-text-div">
                  {formatMessage({
                    id: 'dbi_overlapsteam_continuously_updated',
                  })}
                </div>
              }
              right={
                <>
                  <SearchRecent
                    fetchParams={{ ...fetchParams, page: 1 }}
                    handleClear={handleClearSearch}
                    getTableResultList={getTableSearchList}
                    searchListApi={overlapAnalysisTopchartSteamGamesRankList}
                    pageLogInfo={pageLogInfo}
                    searchType={'overlap-analysis-steam'}
                    initSearchInput={JSON.stringify(fetchParams?.game_code) === '[]'}
                    transTableDataForSearch={transTableDataForSearch}
                  />
                </>
              }
            />
            <SteamGamesTable
              fetchParams={fetchParams}
              records={tableData}
              loading={tableLoading}
              tableTotal={tableTotal}
              tableSelection={[]}
              tableSelectionAll={[]}
              pageSortAttr={{
                tablePageIndex: fetchParams?.page,
                tablePageSize: fetchParams?.page_size,
                currentSortValue: fetchParams?.order,
                currentSortMetric: fetchParams?.order_metric,
                currentOrderSource: fetchParams?.order_type,
                currentRatioType: fetchParams?.ratio_type,
                // currentSortMetric: `${fetchParams?.order_metric}_${fetchParams?.order_source}`,
              }}
              onTableSortChage={onTableSortChage}
              onTablePagingChange={onTablePagingChange}
              entityType={entityType}
              genreSource={'iegg'}
            />
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
};
